import { render } from "./userLogout.vue?vue&type=template&id=56b367b5"
import script from "./userLogout.vue?vue&type=script&lang=js"
export * from "./userLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__